/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ActionButton, BrandColors } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  dividedFooter: {
    '::before': {
      backgroundColor: BrandColors.CLOUD_50,
      content: '""',
      height: 1,
      left: '-32px',
      position: 'absolute',
      right: '-32px',
      top: '-16px',
    },
    marginBottom: '-16px',
    marginTop: 32,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  footerItem: {
    marginLeft: 8,
  },
});

export interface FooterProps {
  alternateButtonLabel?: string;
  disabledReason?: string;
  footerId: string;
  handleAlternateClick?: () => void;
  handleSubmit: () => void;
  isLoading?: boolean;
  showDivider?: boolean;
  submitButtonDisabled?: boolean;
  submitButtonLabel?: string;
}

export const Footer: React.FC<FooterProps> = ({
  alternateButtonLabel,
  handleAlternateClick,
  submitButtonDisabled,
  disabledReason,
  footerId,
  handleSubmit,
  isLoading = false,
  showDivider,
  submitButtonLabel = 'Submit',
}: FooterProps) => {
  const footerClasses = [css(styles.footer), showDivider ? css(styles.dividedFooter) : ''];
  return (
    <div className={footerClasses.join(' ')}>
      {alternateButtonLabel && (
        <ActionButton
          className={css(styles.footerItem)}
          disabled={false}
          id={`${footerId}-alternate-btn`}
          isLoading={false}
          label={alternateButtonLabel}
          onClick={handleAlternateClick}
          theme="tertiary"
        />
      )}
      <ActionButton
        className={css(styles.footerItem)}
        disabled={submitButtonDisabled}
        id={`${footerId}-submit`}
        isLoading={isLoading}
        label={submitButtonLabel}
        onClick={handleSubmit}
        theme="primary"
        tooltipText={disabledReason}
      />
    </div>
  );
};
